import { teachers } from "@/data/teachers";
import { Badge } from "@/components/ui/badge";

const Teachers = () => (
  <div className="pt-24 pb-16 px-4">
    <div className="container mx-auto">
      <div className="text-center mb-12">
        <h1 className="font-heading text-4xl font-bold text-foreground mb-3">Our Instructors</h1>
        <p className="text-muted-foreground max-w-xl mx-auto">
          Passionate educators dedicated to helping your child learn wildly.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
        {teachers.map((t) => (
          <div
            key={t.id}
            className="bg-card rounded-xl border border-border overflow-hidden flex flex-col items-center text-center p-6 shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="w-36 h-36 rounded-full overflow-hidden mb-4 border-4 border-primary/20 shrink-0">
              <img
                src={t.image}
                alt={t.name}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <h3 className="font-heading text-xl font-bold text-foreground">{t.name}</h3>
            <p className="text-sm text-primary font-semibold mb-3">{t.title}</p>
            <p className="text-sm text-muted-foreground leading-relaxed mb-4">{t.bio}</p>
            <div className="flex flex-wrap justify-center gap-1 mt-auto">
              {t.specialties.map((s) => (
                <Badge key={s} variant="secondary" className="text-xs bg-sage-light text-foreground">
                  {s}
                </Badge>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Teachers;
